import { useDmScans } from '@odo/shared-ui';
import { usePatientCard } from '../../../../../hooks/usePatientCard';
import { dmScansQueryConfig } from '../../../../../services/dmScans';
import { markupAvailability, type MarkupAvailability } from './markupAvailability';

export interface ScanMarkupAvailability {
    dmId: number | null;
    availability: MarkupAvailability;
}

export function useScanMarkupAvailability(patientId: string): ScanMarkupAvailability {
    const { data: card } = usePatientCard(patientId);
    const dmId = card?.monitoring?.dmId ?? null;
    const scans = useDmScans(dmScansQueryConfig, patientId, dmId);
    return {
        dmId,
        availability: markupAvailability({
            dmId,
            scansLoading: scans.isLoading,
            scanCount: scans.data?.scans.length ?? 0,
            scansFailed: scans.isError
        })
    };
}
